import React from "react";

const AiSelectionCard = ({ title, active, changeActiveCategory }) => {
  return (
    <div
      onClick={() => changeActiveCategory(title)}
      style={{
        padding: "8px 10px",
        backgroundColor: "#F2F2F2",
        textWrap: "nowrap",
        fontSize: "17px",
        fontWeight: 700,
        borderRadius: "5px",
        border: "1px solid transparent",
        cursor: "pointer",
        whiteSpace: "nowrap",
      }}
      className={active && "ai-bot-active"}
    >
      {title}
    </div>
  );
};

export default AiSelectionCard;
